import { DocumentUpdateForm } from 'components/Pages/Documents';
import { Scaffold } from 'layouts';
import React, { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const DocumentUpdatePage: React.FC = () => {
  const { id } = useParams() as { id: string };
  const navigate = useNavigate();

  const onUpdate = useCallback((): void => {
    navigate('/documentacoes');
  }, [navigate]);

  return (
    <Scaffold>
      <DocumentUpdateForm documentId={id} onUpdate={onUpdate} />
    </Scaffold>
  );
};
